export const HOME = "/";
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const ACCOUNT = '/account';
export const ADMIN = '/admin';
export const PASSWORD_FORGET = '/pw-forget';
export const EVENT = "/events/:eventId";
export const EVENTS = "/events";
export const CREATE_EVENT = "/create-event";
export const ABOUT = "/about";
export const CONTACT = "/contact";


// WEBPACK FOOTER //
// ./src/constants/routes.js